<template>
  <div>
    <TransactionInfo :transaction="transaction" :showInfo="showInfo" @customChange="logChange" ></TransactionInfo>
    <AddRefund v-model="refreshData"></AddRefund>
    <b-card>
      <b-row>
       
        <b-col sm="6" md="3" cols="12">
          <b-form-group label="تاریخ آخرین شارژ:">
                  <div class="form-control">
                   {{lastCreatedAt}}
                  </div>
                </b-form-group>
        </b-col>
        <b-col sm="6" md="3" cols="12">
          <b-form-group label="مبلغ آخرین شارژ (ریال):">
                  <div class="form-control">
                   {{lastAmountCharge}}
                  </div>
                </b-form-group>
        </b-col>
        <b-col sm="6" md="3" cols="12">
          <b-form-group label="موجودی ریفاند(ریال):">
                  <div class="form-control">
                   {{ totalCredit }}
                  </div>
                </b-form-group>
        </b-col>
        <b-col sm="6" md="3" cols="12">
          <b-form-group label="موجودی در انتظار تایید(ریال):">
                  <div class="form-control">
                   {{ totalCharge!=null ? totalCharge : 0 }}
                  </div>
                </b-form-group>
        </b-col>
        <b-col sm="8" md="8" cols="12">
          <p>
            <span class="textColor text-center">
              راهنما:
            </span>
            جهت استفاده از سرویس ریفاند،ابتدا پنل ریفاند خود را شارژ کنید.(شارژ اعمال شده 1 روز کاری بعد قابل استفاده می باشد) سپس به منوی تراکنش رفته و تراکنش مدنظررا پیدا کرده و ریفاند بزنید.
          </p>
        </b-col>
        <b-col sm="4" md="4" cols="12">
          <b-button block  variant="success" @click="add()"
            >شارژ اعتبار</b-button
          >
        </b-col>
      </b-row>
      <br />
      <list-table
        :url="url"
        title="گزارش برگشت وجه (ریفاند)"
        :fields="fields"
        :params="params"
        :refreshData="refreshData"
        :tbody-tr-class="rowClass"
        :btns="btns"
        :excelroute="true"
      ></list-table>
    </b-card>
    <b-modal id="modal-1" title="وضعیت پرداخت" ok-only ok-title="بستن">
      <!-- <div v-if="!message"><i class="spinner"></i></div> -->
      <h4 v-if="message != null" :class="m_class" v-html="message"></h4>
      <b-row v-else
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control border border-0">شماره تراکنش:</div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control">
              {{ refundResult.sale_reference_id }}
            </div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control border border-0">کد رهگیری پرداخت:</div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control">
              {{ refundResult.transaction_id }}
            </div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control border border-0">مبلغ (ریال):</div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control">
              {{ refundResult.amount }}
            </div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control border border-0">بابت:</div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control">شارژ حساب ریفاند</div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control border border-0">وضعیت:</div>
          </b-form-group> </b-col
        ><b-col cols="6">
          <b-form-group>
            <div class="form-control">
              <span class="text-success">موفق</span>
            </div>
          </b-form-group> </b-col
        ><b-col cols="12"
          ><p style="font-size:0.9rem;opacity:0.7">* شارژ حساب شما طی ۲۴ ساعت آینده اعمال خواهد شد.</p></b-col
        ></b-row
      >
    </b-modal>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
import AddRefund from "./AddRefund";
import persianDate from "../../helpers/persianDate";
import TransactionInfo from "./transactionInfo";

export default {
  name: "refunds",
  data() {
    return {
      transaction:null,
      message: null,
      showmodal: true,
      showInfo: false,
      totalCredit: 0,
      lastCreatedAt:0,
      lastAmountCharge:0,
      refreshData: 0,
      m_class: "text-danger",
      url: "refund",
      refundResult: {},
      fields: [
        {
          key: "id",
          label: "کد",
        },
        {
          key: "created_at",
          label: "تاریخ",
          formatter: (value, key, item) => {
             return value ? (
                persianDate.getDateByFormat(value) +
                " ساعت " +
                persianDate.getTime(value)
              ): "-";
          },
        },
         {
          key: "card_holder_pan",
          label: "شماره کارت",
          tdClass: 'ltr'
        },
        {
          key: "website_name",
          label: "نام وبسایت",
          
        },
        {
          key: "refund_tracknumber",
          label: "کد رهگیری تراکنش برگشت",
         
        },
        {
          key: "des",
          label: "توضیحات",
          formatter(value, key, item) {
            var amount = item.bes - item.bed;
            return amount > 0
              ? "شارژ اکانت برگشت وجه"
              : "برگشت وجه تراکنش شماره " + item.transaction_id;
          },
        },
        {
          key: "bes",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            var amount = item.bes - item.bed;
            amount = amount > 0 ? amount : amount * -1;
            return Number(amount).toLocaleString();
          },
          tdClass(value, key, item) {
            var amount = item.bes - item.bed;
            return amount > 0 ? "text-success" : "text-danger";
          },
        },
        {
          key: "karmozd",
          label: "کارمزد (ریال)",
          formatter(value, key, item) {
           
            return value ? value.toLocaleString(): 0;
          },
          tdClass(value, key, item) {
           
            return value  > 0 ? "text-success" : "text-danger";
          },
        },
         {
          key: "totalsum",
          label: "مانده(ریال)",
          formatter(value, key, item) {
           
            return value ? value.toLocaleString(): 0;
          },
        },
         {
            key: "btns",
            label: "عملیات",
          },
        // {
        //   key: "created_at",
        //   label: "رسید",
        // },
        // {
        //   key: "details",
        //   label: "جزییات",
        // },
      ],
       btns: [
          {
            icon: "eye-fill",
            title:"مشاهده",
            handler: (t) => {
              this.transaction = t;
             this.showInfo=true;
            },
          }
       ],
      params: [
        {
            label: "از تاریخ:",
            field: "dateFrom",
            type: "date-picker",
          },
          {
            label: "تا تاریخ:",
            field: "dateTo",
            type: "date-picker",
          },
          {
            field: "website",
            label: "وبسایت:",
            type: "text"
          },
          {
            field: "amount",
            label: "مبلغ (ریال):",
            type: "number"
          },
          {
            field: "refundTrackNumber",
            label: "کد پیگیری تراکنش برگشت:",
            type: "text"
          },
          {
            field: "cardNumber",
            label: "شماره کارت:",
            type: "text"
          },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
    AddRefund,
    TransactionInfo,
  },
  methods: {
    add: function () {
      this.$bvModal.show("addrefund-modal");
    },
    rowClass(item, type) {
      var amount = item.bes - item.bed;
      return amount > 0 ? "text-success" : "text-danger";
    },
    getRefundable() {
      httpHelper.getData("getrefundprice").then((res) => {
        this.totalCredit = Number(res.result.totalprice).toLocaleString();
        this.totalCharge = Number(res.result.totalCharge).toLocaleString();
        this.lastAmountCharge = Number(res.result.bes).toLocaleString();
        this.lastCreatedAt = res.result.created_at!=null ? persianDate.getDateByFormat(res.result.created_at) +" "+ persianDate.getTime(res.result.created_at) : null;
      });
    },
    logChange(e){
      this.showInfo=e;
    }
  },
  mounted() {

    if (this.$route.query.status) {
      httpHelper
        .getData(
          "refund/verify?token=" +
            this.$route.query.token +
            "&status=" +
            this.$route.query.status
        )
        .then((res) => {
          if (res.success == false) {
            this.m_class = "text-danger";
            this.message = "پرداخت با موفقیت انجام نشد";
          } else {
            this.m_class = "text-success";
            this.refundResult = res.result;
          }
          this.refreshData = Math.floor(Math.random() * (100 - 1 + 1)) + 1;
          this.getRefundable();
          this.$bvModal.show("modal-1");
        });
      this.$bvModal.show("modal-1");
    }
    this.getRefundable();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "گزارش برگشت وجه (ریفاند)",
      },
    ]);
  },
};
</script>
<style>
.textColor{
  color: rgb(255, 4, 4);
}
.ltr{
  direction: ltr;
}
</style>
